// @ts-ignore
import { BlipChat } from 'blip-chat-widget';

import { ICustomer } from '@/interfaces/Customer';

import icon from '@/assets/images/headset.svg';

let blipChat: BlipChat | null = null;
const { NODE_ENV, VUE_APP_BLIPCHAT_EVA, VUE_APP_BLIPCHAT_PEQUENA_EVA } = process.env;
const isDevelopment = NODE_ENV === 'development';
const appkey = isDevelopment ? VUE_APP_BLIPCHAT_PEQUENA_EVA : VUE_APP_BLIPCHAT_EVA;

const uuidv4 = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = Math.random() * 16 | 0;
    const v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
};

export const buildChat = (customer: ICustomer | null) => {
  // TODO: remember to remove this if, this is only for purpose of tests
  if (process.env.VUE_APP_BLIPCHAT_ACTIVE === 'false') {
    return;
  }

  destroyChat();

  if (customer && customer.acta_user_id) {
    buildAuth(customer);
  } else {
    buildAsGuest();
  }
};

export const destroyChat = () => {
  if (blipChat) {
    blipChat.destroy();
  }
};

const buildAsGuest = (): void => {
  blipChat = new BlipChat();

  blipChat.withAppKey(appkey);
  blipChat.withButton({ color: '#b81334', icon });
  blipChat.build();
};

const buildAuth = (customer: ICustomer): void => {
  blipChat = new BlipChat();
  const uniqueId = uuidv4();

  blipChat.withAppKey(appkey);
  blipChat.withButton({ color: '#b81334', icon });
  blipChat.withAuth({
    authType: BlipChat.DEV_AUTH,
    userIdentity: `${uniqueId}____v2`,
    userPassword: `${uniqueId}____v2`,
  });
  blipChat.withAccount({
    fullName: customer.name,
    extras: {
      storedId: customer.acta_user_id,
      cpf: customer.document,
      fluxo: 'checkout',
    },
  });
  blipChat.build();
};